import React from 'react';
import { Helmet } from 'react-helmet';

const PostieHelmet = props => {
  return (
    <Helmet>
      <script type='text/javascript'>{`
        ;(function(p,l,o,w,i,n,g){if(!p[i]){p.GlobalSnowplowNamespace=p.GlobalSnowplowNamespace||[];
        p.GlobalSnowplowNamespace.push(i);p[i]=function(){(p[i].q=p[i].q||[]).push(arguments)
        };p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1;
        n.src=w;g.parentNode.insertBefore(n,g)}}(window,document,"script","//d18p8z0ptb8qab.cloudfront.net/lp.js","letterpress"));

        window.letterpress('newTracker', 'mycljcoll', 't.getletterpress.com', {
          appId: 'upbzherm',
          discoverRootDomain: true,
          forceSecureTracker: '',
          contexts: {
            webPage: true,
            performanceTiming: true,
            gaCookies: true,
            geolocation: false
          }
        });
      `}</script>
    </Helmet>
  );
};

export default PostieHelmet;
